import { Reveal } from "./Reveal";

export const SectionHeading = ({ accent, title, intro, align = "left" }) => (
  <div className={align === "center" ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
    <Reveal>
      <p className="font-hand text-2xl sm:text-3xl text-[#8A9B87] -rotate-1">{accent}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-3 text-3xl sm:text-4xl font-light tracking-tight text-[#2E2E2C]">{title}</h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.14}>
        <p className="mt-5 text-base md:text-lg text-[#2E2E2C]/70 leading-relaxed">{intro}</p>
      </Reveal>
    )}
  </div>
);
